import { create } from "zustand";

interface FMRadioState {
  currentFMId: string | null;
  setCurrentFMId: (id: string | null) => void;
  audioRef: HTMLAudioElement | null;
  setAudioRef: (ref: HTMLAudioElement | null) => void;
  stopCurrent: () => void;
}

export const useFMRadioStore = create<FMRadioState>((set, get) => ({
  currentFMId: null,
  setCurrentFMId: (id) => set({ currentFMId: id }),
  audioRef: null,
  setAudioRef: (ref) => set({ audioRef: ref }),
  stopCurrent: () => {
    const audio = get().audioRef;
    if (audio) {
      try {
        audio.pause();
        audio.currentTime = 0;
      } catch (e) {
        console.log("Error stopping radio audio:", e);
      }
    }
    set({ currentFMId: null, audioRef: null });
  },
}));
